export const modifyCategoryTreeDataHandler = (
  type, // menu or megaMenu
  array,
  parentURL = '',
  parentBreadcrumb = []
) => {
  return (array || [])
    .filter(
      (cat) =>
        cat.is_active &&
        (type === 'cats'
          ? cat?.include_in_menu == '1' &&
            (cat?.level === 2 ? cat?.include_in_mega_menu === true : true)
          : type === 'footer'
            ? cat?.include_in_footer === true
            : type === 'menu'
              ? cat.include_in_menu === '1'
              : cat.include_in_mega_menu) &&
        cat?.product_count > 0
    )
    .map((cat) => {
      // Set currentURL for each category
      const currentURL = `${parentURL}/${cat.innova_url}`;

      // Build up the breadcrumb path
      const breadcrumb = [
        ...parentBreadcrumb,
        {
          name: cat.name,
          url: currentURL,
        },
      ];

      const modifiedCategory = {
        ...cat,
        currentURL,
        breadcrumb,
      };

      // If there are children, apply recursion to include them
      if (cat.children_data?.length && type !== 'footer') {
        modifiedCategory.children_data = modifyCategoryTreeDataHandler(
          type,
          cat.children_data,
          currentURL,
          breadcrumb
        );
      }

      return modifiedCategory;
    });
};

export const modify_category_tree = (treeData, parentName = null) => {
  if (!treeData || !Array.isArray(treeData)) return [];

  return treeData.map((item) => {
    const modifiedItem = {
      ...item,
      parent_name: parentName,
    };

    if (
      item.children_data &&
      Array.isArray(item.children_data) &&
      item.children_data.length > 0
    ) {
      modifiedItem.children_data = modify_category_tree(
        item.children_data,
        item.name
      );
    }

    return modifiedItem;
  });
};

export const handleFilterArrayToString = (filters) => {
  if (!filters || Array.isArray(filters) === false) return '';

  const sortedFilters = (filters || [])?.sort((a, b) =>
    a?.code?.localeCompare(b?.code)
  );

  let str = '';
  sortedFilters?.forEach((item) => {
    switch (item.type) {
      case 'price':
        str += `&minPrice=${item?.range?.[0]}&maxPrice=${item?.range?.[1]}`;
        break;
      case 'sort':
        str += `&${item?.code}`;
        break;
      case 'filter':
        str += `&${item?.code}=${item?.key}`;
        break;
      default:
    }
  });

  return str.slice(1);
};

export function formatPrice(price) {
  if (isNaN(price)) return null;
  const fixedPrice = Number(price)?.toFixed(2);
  const [IntPrice, floatPrice] = String(fixedPrice)?.split('.');
  return Number(floatPrice === '00' ? IntPrice : fixedPrice);
}

export const validatePrice = (prices) => {
  // const now = new Date();
  // const startDate = prices?.discounted_price_from
  //   ? new Date(prices?.discounted_price_from)
  //   : null;
  // const endDate = prices?.discounted_price_to
  //   ? new Date(prices?.discounted_price_to)
  //   : null;

  let originalPrice = prices?.original_price;
  let specialPrice = prices?.price;
  let discount =
    originalPrice > specialPrice
      ? Math.round(((originalPrice - specialPrice) / originalPrice) * 100)
      : 0;

  // if (endDate && (now >= startDate && now <= endDate)) {
  //   specialPrice = prices?.price || prices?.discounted_price;
  //   discount = ((originalPrice - specialPrice) / originalPrice) * 100;
  // }

  return {
    originalPrice: formatPrice(+originalPrice),
    specialPrice:
      originalPrice === specialPrice ? null : formatPrice(+specialPrice),
    discount: specialPrice === originalPrice ? null : formatPrice(discount),
  };
};

export const priceFormatedObject = (item) => {
  return {
    discounted_price:
      item?.price_incl_tax ||
      item?.extension_attributes?.special_price ||
      item?.prices_with_tax?.discounted_price ||
      0,
    original_price:
      item?.extension_attributes?.price ||
      item?.prices_with_tax?.price ||
      item?.price_incl_tax ||
      0,
    discounted_price_from:
      item?.extension_attributes?.special_price_from ||
      item?.prices_with_tax?.discounted_price_from,
    discounted_price_to:
      item?.extension_attributes?.special_price_to ||
      item?.prices_with_tax?.discounted_price_to ||
      '',
  };
};

export const extractCategoryId = (catId) => {
  if (!catId) return null;
  return catId.at(-1)?.split('-c-')?.at(0);
};
export const getCurrentCategoryName = (categoryData, categoryId) => {
  if (!categoryData?.products || !categoryId) return null;
  return categoryData?.products[0]?._category_?.main_category?.name;
};

export const findCategoryByKey = (categoryTree, key, value) => {
  if (!categoryTree) {
    return null;
  }

  if (categoryTree[key] === value) {
    return categoryTree;
  }

  for (let child of categoryTree.children_data || []) {
    const found = findCategoryByKey(child, key, value);
    if (found) {
      return found;
    }
  }

  return null;
};

/**
 * Groups banners by `group_id` and sorts them in ascending order.
 * @param {Array} banners - List of banner objects with a `group_id` property.
 * @returns {Array} - An array of grouped and sorted banner arrays.
 */
export const groupAndSortBanners = (banners) => {
  const grouped = banners.reduce((acc, banner) => {
    (acc[banner.group_id] ||= []).push(banner);
    return acc;
  }, {});

  return Object.values(grouped).sort((a, b) => a[0].group_id - b[0].group_id);
};

/**
 * Splits products into chunks and associates them with grouped banners.
 * @param {Array} products - List of product objects.
 * @param {Array} banners - List of banner objects to be grouped.
 * @param {number} [chunkSize=6] - Number of products per chunk.
 * @returns {Object} - An object containing:
 *   - `chunks`: Array of chunked products with their corresponding banners.
 *   - `bannerCount`: Total number of banner groups.
 */
export const chunkProductsWithBanners = (products, banners, chunkSize = 6) => {
  const groupedBanners = groupAndSortBanners(banners);
  const bannerCount = groupedBanners.length;

  return {
    chunks: Array.from(
      { length: Math.ceil(products.length / chunkSize) },
      (_, i) => ({
        products: products.slice(i * chunkSize, (i + 1) * chunkSize),
        banners: groupedBanners[i] || [],
      })
    ),
    bannerCount,
  };
};

export const prepareFilters = (aggregate = []) => {
  return aggregate.reduce(
    (groupedFilters, { label, filter_key, filterable_values }) => {
      if (!filterable_values?.length) return groupedFilters;

      const filter = {
        title: label,
        code: filter_key,
        list: filterable_values,
      };

      switch (filter_key) {
        case 'categories':
          groupedFilters.categories.push(filter);
          break;
        case 'color':
          groupedFilters.colors.push(filter);
          break;
        default:
          groupedFilters.others.push(filter);
          break;
      }

      return groupedFilters;
    },
    {
      categories: [],
      colors: [],
      others: [],
    }
  );
};

export function generateSlugs(categories, parentSlug = '') {
  if (!Array.isArray(categories)) return {};
  let slugs = {};

  categories
    ?.filter((cat) => cat?.is_active && cat?.product_count > 0)
    ?.forEach((category) => {
      // Build the current slug using the parent slug and the current category's url_key
      const currentSlug = parentSlug
        ? `${parentSlug}/${category?.innova_url}`
        : category?.innova_url;

      // Add the current slug to the slugs map
      slugs[category?.id] = currentSlug;

      // Recursively generate slugs for the child categories
      if (category?.children_data && category?.children_data.length > 0) {
        const childSlugs = generateSlugs(category?.children_data, currentSlug);
        slugs = { ...slugs, ...childSlugs };
      }
    });

  return slugs;
}
